import { createSlice } from '@reduxjs/toolkit';
import { fetchEvaluationCriteria, submitEvaluation, fetchEvaluationData } from './evaluationThunk';

const initialState = {
    criteria: [],
    quantitative: [],
    qualitative: [],
    loading: false,
    submitting: false,
    error: null,
    success: false,
    existingData: null,
};

const evaluationSlice = createSlice({
    name: 'evaluation',
    initialState,
    reducers: {
        resetEvaluation: (state) => {
            state.success = false;
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchEvaluationCriteria.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchEvaluationCriteria.fulfilled, (state, action) => {
                state.loading = false;
                state.criteria = action.payload; 
            })
            .addCase(fetchEvaluationCriteria.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload?.message || 'Gagal mengambil kriteria';
            })
            .addCase(submitEvaluation.pending, (state) => {
                state.submitting = true;
                state.error = null;
                state.success = false;
            })
            .addCase(submitEvaluation.fulfilled, (state) => {
                state.submitting = false;
                state.success = true;
            })
            .addCase(submitEvaluation.rejected, (state, action) => {
                state.submitting = false;
                state.error = action.payload?.message || 'Gagal menyimpan evaluasi';
            })
            .addCase(fetchEvaluationData.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchEvaluationData.fulfilled, (state, action) => {
                state.loading = false;
                state.existingData = action.payload;
            })
            .addCase(fetchEvaluationData.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload?.message || 'Gagal mengambil data evaluasi';
            });
    },
});

export const { resetEvaluation } = evaluationSlice.actions;
export default evaluationSlice.reducer;